import React, { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormContext, useWatch } from 'react-hook-form'
import { Divider, Form, Header, Icon, SemanticICONS } from 'semantic-ui-react'
import { ThemeContext } from 'styled-components'
import FileUpload from '~/components/FileUpload'
import Dialog from '~/components/Dialog'
import ErrorIcon from '~/pages/Farmer/ClimateCheck/AnswerClimateCheck/Steps/ErrorIcon'
import { StyledFileSection } from '~/pages/Manager/Profile/RegistrationTab/AddRegistration/style'
import { getFileIcon, getFileTypeLabel } from '../utils'

const ACCEPTED_FILE_TYPES = {
  'application/pdf': ['.pdf'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
  'image/bmp': ['.bmp'],
  'image/gif': ['.gif'],
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/png': ['.png']
}
const FILE_MIME_TYPES = ['xlsx', 'pdf', 'bmp', 'gif', 'jpg', 'jpeg', 'png']
const MAX_FILE_SIZE_MB = 10
const SUPPORTED_FORMATS_TEXT = 'PDF, XLSX, BMP, GIF, JPG, PNG'

const ReceiptUploadSection: React.FC = () => {
  const { t } = useTranslation()
  const { control, setValue } = useFormContext()
  const { firstColor } = useContext(ThemeContext)

  const [isPreviewOpen, setIsPreviewOpen] = useState(false)

  const watchPurchaseReceiptFile = useWatch({ control, name: 'purchaseReceiptFile' })

  const handleFileChange = (fileData, fileName) => {
    setValue('purchaseReceiptFile', { data: fileData, name: fileName })
  }

  const handlePreviewFile = () => {
    if (watchPurchaseReceiptFile?.data) {
      setIsPreviewOpen(true)
    }
  }

  const handleClosePreview = () => {
    setIsPreviewOpen(false)
  }

  return (
    <>
      <Header as='h4'>{t('Purchase Receipt')}</Header>
      <Divider />

      <Form.Field>
        <label style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
          {t('Upload purchase receipt')}
          <ErrorIcon control={control} name='purchaseReceiptFile' />
        </label>
        <StyledFileSection $primaryColor={firstColor}>
          <div className='file-icon'>
            <Icon name={getFileIcon(watchPurchaseReceiptFile?.name) as SemanticICONS} size='large' />
          </div>
          <div className='file-info'>
            <div className='file-label'>{getFileTypeLabel(watchPurchaseReceiptFile?.name)}</div>
            {watchPurchaseReceiptFile?.name ? (
              <div className='file-name' onClick={handlePreviewFile}>
                {watchPurchaseReceiptFile.name}
              </div>
            ) : (
              <div className='file-placeholder'>{t('No file selected')}</div>
            )}
          </div>
          <div className='file-actions'>
            <FileUpload
              button
              encodeFiles
              accept={ACCEPTED_FILE_TYPES}
              mimeTypes={FILE_MIME_TYPES}
              sizeLimitInMB={MAX_FILE_SIZE_MB}
              onChange={handleFileChange}
            />
          </div>
        </StyledFileSection>
        <small style={{ color: 'gray', marginTop: '0.5em', display: 'block' }}>
          {t('Supported formats')}: {SUPPORTED_FORMATS_TEXT}. {t('Max size')}: {MAX_FILE_SIZE_MB}MB
        </small>
      </Form.Field>

      <Dialog
        type='preview'
        textHeader={t('Purchase Receipt Preview')}
        heightContent='90%'
        heightDialog='80%'
        isDialogOpen={isPreviewOpen}
        noScrollingContent={false}
        style={{ width: '70%' }}
        textClose={t('Close')}
        handleClose={handleClosePreview}
        textContent={
          <div style={{ position: 'relative', width: '100%', minHeight: '500px', height: '93%' }}>
            <iframe
              src={watchPurchaseReceiptFile?.data ? `${watchPurchaseReceiptFile.data}#toolbar=1&navpanes=0&view=FitH` : 'about:blank'}
              width='100%'
              height='100%'
              style={{ minHeight: 500 }}
            />
          </div>
        }
      />
    </>
  )
}

export default ReceiptUploadSection
